import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Ministries } from "./pages/Ministries";
import { CalendarPage } from "./pages/CalendarPage";
import { MusicMinistry } from "./pages/MusicMinistry";
import { SpeakerNotes } from "./pages/SpeakerNotes";
import { PrayerTestimonies } from "./pages/PrayerTestimonies";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ministries" element={<Ministries />} />
          <Route path="/calendar" element={<CalendarPage />} />
          <Route path="/music" element={<MusicMinistry />} />
          <Route path="/speaker-notes" element={<SpeakerNotes />} />
          <Route path="/prayer" element={<PrayerTestimonies />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
